import React from 'react';
import Drawer from '@components/drawer/Drawer';
import OrdersMissingBuyerPhone from '@components/drawer/subcomponents/OrdersMissingBuyerPhone';

interface DrawerOrdersMissingBuyerPhoneProps {
  isActive: boolean;
  onUpdateOrderCount: any;
  onClose: any;
  initialTotalContracts: number;
}

const DrawerOrdersMissingBuyerPhone = (props: DrawerOrdersMissingBuyerPhoneProps) => {
  return (
    <Drawer isActive={props.isActive} onClose={props.onClose}>
      {props.isActive && (
        <OrdersMissingBuyerPhone
          onUpdateOrderCount={props.onUpdateOrderCount}
          initialTotalContracts={props.initialTotalContracts}
        />
      )}
    </Drawer>
  );
};

export default DrawerOrdersMissingBuyerPhone;
